import { render, staticRenderFns } from "./IpApply.vue?vue&type=template&id=6dba344a&scoped=true&"
import script from "./IpApply.vue?vue&type=script&lang=js&"
export * from "./IpApply.vue?vue&type=script&lang=js&"
import style0 from "./IpApply.vue?vue&type=style&index=0&id=6dba344a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dba344a",
  null
  
)

export default component.exports